import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Boston.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Quality-Driven Mobile App Development Company in Boston</h2>
            <p>
              We initiate our inventive approach by thoroughly comprehending
              your business objectives, target audience, and industry trends.
              TekRevol's experts collaborate seamlessly to create apps that
              engage users and provide flawless functionality. TekRevol, a
              leading mobile app development company in Boston leverages the
              potential of cutting-edge tools and platforms, guaranteeing that
              your app not only meets industry benchmarks but surpasses them,
              all while delivering an immersive user experience. As innovation
              speeds up, we position ourselves as a beacon of progress,
              welcoming the future with open arms. Our dedication surpasses mere
              app creation – we partner with you to attain remarkable growth and
              steadfast sustainability.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
